import { PAGINATED_SIZE } from '@application/components/controllers/pages/ArticleListPageController/constants';
import {
  Button,
  CardItemContainer,
  CardItemStud,
  CardItemWrapper,
  Container,
  EmptyOverlay,
  FiltersWithModal,
  HeaderSearch,
  Label,
  LoadMoreText,
  LoadMoreWrapper,
  Section,
} from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import type { StudListPageProps } from '..';
import { Filters } from './components/Filters';

export * from './types';

export const StudListPage: FC<StudListPageProps> = (props) => {
  const {
    items = [],
    loading = false,
    canLoadMore,
    loadMoreText,
    loadMoreLoading,
    onLoadMoreClick,
    filtersModal,
    formOptions,
  } = props;
  const { translate } = useTranslation();

  return (
    <>
      <HeaderSearch
        title={translate('studList.title')}
        subtitle={<Label content={translate('studList.subtitle')} size="large" theme="blue" />}
      />

      <Container>
        <Section>
          <FiltersWithModal {...filtersModal}>
            <Filters options={formOptions} />
          </FiltersWithModal>
        </Section>
      </Container>

      <Container>
        {!loading && !items?.length && <EmptyOverlay />}

        <CardItemContainer>
          {loading &&
            Array(PAGINATED_SIZE)
              .fill(undefined)
              .map((_, index) => (
                <CardItemWrapper key={index}>
                  <CardItemStud loading />
                </CardItemWrapper>
              ))}

          {!loading &&
            items.map((item, index) => (
              <CardItemWrapper key={index}>
                <CardItemStud {...item} />
              </CardItemWrapper>
            ))}
        </CardItemContainer>

        {canLoadMore && (
          <LoadMoreWrapper>
            <LoadMoreText>{loadMoreText}</LoadMoreText>
            <Button
              shrink
              color="blue"
              outlined
              loading={loadMoreLoading}
              onClick={onLoadMoreClick}
            >
              {translate('common.buttons.seeMore')}
            </Button>
          </LoadMoreWrapper>
        )}
      </Container>
    </>
  );
};
